import React, { useState, useEffect } from "react";
import axios from "axios";
import VGMModal from "../VGMModal/VGMModal";
import EvnVar from "../../EnvVar";
import Cookies from "js-cookie";

const VGMReportDetailsAPI = ({
  branchId,
  columnId,
  modalOpen,
  setModalOpen,
}) => {
  const [vgmDetails, SetVgmDetails] = useState([]);

  useEffect(() => {
    const fetchVGMDetails = async () => {
      const baseURL = EvnVar();
      const token = Cookies.get("jwt");

      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${baseURL}/user/${columnId}/${branchId}`,
        headers: {
          Authorization: token,
        },
        withCredentials: true,
      };

      try {
        const response = await axios.request(config);
        // console.log("response.data", response.data);
        SetVgmDetails(response.data); // Uncomment to set data
      } catch (error) {
        console.log(error);
      }
    };

    fetchVGMDetails();
  }, [branchId, columnId]); // Effect runs when branchId or columnId changes

  return (
    <>
      {
        <VGMModal
          vgmDetails={vgmDetails}
          titleHeading={columnId}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
        />
      }
    </>
  );
};

export default VGMReportDetailsAPI;
